export default __webpack_public_path__ + "static/media/3143.bc7257dd.jpg";